var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 0.0625H1.05469C0.463992 0.0625 0 0.526492 0 1.11719V6.39062V8.5H36V6.39062V1.11719C36 0.526492 35.536 0.0625 34.9453 0.0625Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34375 4.21875C5.92622 4.21875 6.39844 3.74653 6.39844 3.16406C6.39844 2.58159 5.92622 2.10938 5.34375 2.10938C4.76128 2.10938 4.28906 2.58159 4.28906 3.16406C4.28906 3.74653 4.76128 4.21875 5.34375 4.21875ZM9.5625 4.21875C10.145 4.21875 10.6172 3.74653 10.6172 3.16406C10.6172 2.58159 10.145 2.10938 9.5625 2.10938C8.98003 2.10938 8.50781 2.58159 8.50781 3.16406C8.50781 3.74653 8.98003 4.21875 9.5625 4.21875ZM13.7812 4.21875C14.3637 4.21875 14.8359 3.74653 14.8359 3.16406C14.8359 2.58159 14.3637 2.10938 13.7812 2.10938C13.1988 2.10938 12.7266 2.58159 12.7266 3.16406C12.7266 3.74653 13.1988 4.21875 13.7812 4.21875ZM0 6.32812V26.3672C0 26.9579 0.463992 27.4219 1.05469 27.4219H6.84148C6.64362 26.7294 6.53681 26.0239 6.47156 25.3125H8.60126C8.68493 26.0304 8.82232 26.742 9.07734 27.4219H12.9164C12.8321 26.7469 12.818 26.0251 12.7898 25.3125H14.8688C14.8983 26.0304 14.9477 26.742 15.0468 27.4219H20.9531C21.0523 26.742 21.1016 26.0304 21.1311 25.3125H23.2101C23.1819 26.0251 23.1678 26.7469 23.0835 27.4219H26.9437C27.1856 26.7529 27.3194 26.0389 27.4013 25.3125H29.5292C29.4643 26.0324 29.3573 26.7403 29.1585 27.4219H34.9453C35.536 27.4219 36 26.9579 36 26.3672V6.32812H0Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6523 19.6594C28.6313 19.6383 28.6313 19.6171 28.6313 19.596C28.6103 19.5539 28.568 19.5117 28.5469 19.4484C26.7117 15.4406 22.6827 12.6562 18 12.6562C13.3173 12.6562 9.28828 15.4406 7.45312 19.4484C7.43203 19.5117 7.38977 19.5539 7.36882 19.596C7.36882 19.6171 7.36882 19.6383 7.34773 19.6594C6.73587 21.0515 6.39844 22.6335 6.39844 24.2578C6.39844 25.3336 6.54609 26.3883 6.84148 27.4219H9.07741C8.69773 26.4094 8.50781 25.3336 8.50781 24.2578C8.50781 23.1398 8.69773 22.0851 9.05625 21.0937H12.9164C12.7898 22.1273 12.7265 23.2031 12.7265 24.2578C12.7265 25.3336 12.7898 26.4094 12.9164 27.4219H15.0468C14.8993 26.4094 14.8359 25.3336 14.8359 24.2578C14.8359 23.1188 14.8993 22.0641 15.0468 21.0937H20.9531C21.1006 22.0641 21.164 23.1188 21.164 24.2578C21.164 25.3336 21.1006 26.4094 20.9531 27.4219H23.0835C23.2101 26.4094 23.2734 25.3336 23.2734 24.2578C23.2734 23.2031 23.2101 22.1273 23.0835 21.0937H26.9437C27.3023 22.0851 27.4921 23.1398 27.4921 24.2578C27.4921 25.3548 27.3022 26.4305 26.9437 27.4219H29.1585C29.4539 26.4094 29.6016 25.3548 29.6016 24.2578C29.6016 22.6335 29.2641 21.0515 28.6523 19.6594ZM13.275 18.9844H10.1109C11.1867 17.4023 12.7054 16.1577 14.4984 15.4406C13.9712 16.432 13.5704 17.6555 13.275 18.9844ZM15.4266 18.9844C16.0805 16.3054 17.1562 14.7656 18 14.7656C18.8438 14.7656 19.9195 16.3054 20.5734 18.9844H15.4266ZM22.725 18.9844C22.4297 17.6555 22.0289 16.432 21.5016 15.4406C23.2946 16.1577 24.8133 17.4023 25.8891 18.9844H22.725Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18,
    y1: 8.5,
    x2: 18,
    y2: 0.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D61DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D8DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18,
    y1: 27.4219,
    x2: 18,
    y2: 2.10938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18,
    y1: 27.4219,
    x2: 18,
    y2: 12.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D61DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D8DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomain);
export default __webpack_public_path__ + "static/media/domain.dc67ea0c3ba5eed5ad1de5685a117b2c.svg";
export { ForwardRef as ReactComponent };